export const SOLAR_MANAGER_DOMAIN = 'https://web.solar-manager.ch'
export const MAIN_SOLAR_DOMAIN = 'https://www.solarmanager.ch'
export const BURKHALTER_LOGIN = 'https://main-api.solar-manager.ch/auth/burkhalter-login'